<p-dialog
  [appendTo]="'body'"
  [breakpoints]="{ '7680px': '25vw', '1920px': '35vw', '1024px': '50vw', '450px': '90vw' }"
  [ngClass]="{ 'fixed left-0 top-0 z-50 h-full w-full bg-black bg-opacity-10 backdrop-blur-sm': visible }"
  [styleClass]="'rounded-t-xl'"
  contentStyleClass="rounded-b-xl"
  [(visible)]="visible"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '50vw', height: 'auto' }">
  <ng-template pTemplate="headless">
    <div class="grid h-full w-full grid-cols-1 gap-2 rounded-lg bg-gray-100">
      <div class="flex flex-col justify-center gap-2 px-8 py-8 items-center">
        <div class="text-center text-lg font-bold text-gray-900">
          <p>
            Tu sesión está a punto de expirar.
          </p>
          <p>
            Haz clic en "Mantener sesión" en los próximos {{ countdown }} segundos para continuar.
          </p>
          <br />
          <button class="btn btn-primary" (click)="stayActive.emit()">Mantener sesión</button>
        </div>
      </div>
    </div>
  </ng-template>
</p-dialog>
